export enum IceHockeyStatId {
  NumberOfPenalties = 709,
  PenaltyMinutes = 82,
  TotalShots = 19,
  ShotsOnTarget = 20,
  ShotsOffTarget = 21,
  AttemptsBlocked = 97,
}
